module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0057.jpg?v=86e87cb8";